import * as React from "react";
// import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { AppProvider } from "../../ContextApi/AppProvider";
import { useContext } from "react";
import { ClienteService } from "../../Services/ClienteService";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Cliente,
  FormPesquisarCliente,
  initialStateCliente,
} from "../Shared/Interfaces/Cliente";
import ModalEditarCliente from "./ModalEditarClientes";
import { CadastroService } from "../../Services/CadastrosService";
import { TipoCadastro } from "../Shared/Enums/TipoCadastro";
import DataItem from "../Shared/Interfaces/DataItem";
import colors from "../../theme/colors";

const clienteService = new ClienteService();
const cadastroService = new CadastroService();
// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: "center",
//   color: theme.palette.text.secondary,
// }));

interface Column {
  id:
    | "id"
    | "nome"
    | "documento"
    | "telefone"
    | "email"
    | "comoConheceu"
    | "cep"
    | "logradouro"
    | "numero"
    | "complemento"
    | "bairro"
    | "cidade"
    | "estado";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: "id", label: "Id", minWidth: 5 },
  { id: "nome", label: "Nome", minWidth: 120 },
  { id: "documento", label: "Documento", minWidth: 20 },
  { id: "telefone", label: "Telefone", minWidth: 20, align: "right" },
  { id: "comoConheceu", label: "Como Conheceu", minWidth: 60, align: "right" },
  { id: "cep", label: "Cep", minWidth: 30, align: "right" },
  { id: "logradouro", label: "Logradouro", minWidth: 70, align: "right" },
  { id: "numero", label: "Nº", minWidth: 8, align: "right" },
  { id: "bairro", label: "Bairro", minWidth: 60, align: "right" },
  { id: "cidade", label: "Cidade", minWidth: 60, align: "right" },
  { id: "estado", label: "UF", minWidth: 20, align: "right" },
];

export default function ConsultarClientes() {
  const contextApi = useContext(AppProvider);
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState<Cliente[]>([]);
  const [clienteEdicao, setClienteEdicao] =
    React.useState<Cliente>(initialStateCliente);
  const [formPesquisar, setFormPesquisar] =
    React.useState<FormPesquisarCliente>({
      nome: "",
      documento: "",
    });
  const [canaisDeComunicacao, setCanaisDeComunicacao] = React.useState<DataItem[]>([]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const PesquisarPor = (formPesquisar: FormPesquisarCliente) => {
    const filtroPesquisa: FormPesquisarCliente = {
      nome: formPesquisar.nome,
      documento: formPesquisar.documento,
    };

    clienteService
      .buscarPor(filtroPesquisa)
      .then((response) => {
        if (response.status == 200) {
          setRows(response.data);
        } else {
          contextApi.showMessage(
            "Erro ao Pesquisar, tente novamente!",
            true,
            "error"
          );
        }
      })
      .catch((error) => {
        contextApi.showMessage(error.response.data, true, "error");
      });
  };

  const handleInputPesquisar = (
    fieldName: keyof FormPesquisarCliente,
    value: string
  ) => {
    setFormPesquisar((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };
  const fetchData = async () => {
    try {
      const response = await clienteService.getAll("/api/Clientes/Buscar");
      const data = response.data;
      setRows(data);
    } catch (e) {
      console.error("Erro ao buscar dados da API:", e);
    }
  };

  const getCanaisDeComunicacao = async () => {
    try {
      const response = await cadastroService.getAll(
        `/api/Cadastros/Buscar?tipoCadastro=${TipoCadastro.CanaisDeComunicacao}`
      );
      setCanaisDeComunicacao(response.data || []);
    } catch (e) {
      console.error("Erro ao buscar Canais de Comunicação:", e);
    }
  };
  const handleDeleteItem = (item: Cliente) => {
    clienteService
      .deleteItem(`/api/Clientes/Deletar/${item.id}`)
      .then((response) => {
        if (response.status == 204) {
          contextApi.showMessage("item excluído com sucesso!", true, "success");
          fetchData();
        } else {
          contextApi.showMessage(
            "Erro ao excluir o item, tente novamente!",
            true,
            "error"
          );
        }
      })
      .catch((error) => {
        contextApi.showMessage(error.response.data.message, true, "error");
      });
  };
  /* Controles da modal de resumo */
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = (item: Cliente) => {
    setClienteEdicao(item);
    setOpenModal(true);
  };
  const handleCloseModal = () => setOpenModal(false);
  React.useEffect(() => {
    fetchData();
    getCanaisDeComunicacao();
  }, []);

  const ConcluirEdicao = (cliente: Cliente) => {
    setLoading(true);
    clienteService.putCliente(cliente).then((response) => {
      if (response.status == 200) {
        contextApi.showMessage(
          "Cliente Atualizado com sucesso!",
          true,
          "success"
        );
        fetchData();
        handleCloseModal();
        setLoading(false);
      } else {
        contextApi.showMessage(
          "Erro ao Atualizar o Cliente, tente novamente!",
          true,
          "error"
        );
        setLoading(false);
      }
    });
  };

  return (
    <Box sx={{ flexGrow: 1, p: 1 }}>
      <Paper sx={{ p: 1 }}>
        <Grid container spacing={1}>
          {/* Cabeçalho */}
          <Grid item xs={12}>
            <Paper sx={{ p: 0.5, bgcolor: '#f8f9fa', mb: 1 }}>
              <h4 style={{ margin: '0 0 0 0', color: colors.bluePrimary, textAlign: 'left' }}>
                👥 Consultar Clientes
              </h4>
            </Paper>
          </Grid>

          {/* Seção de Pesquisa */}
          <Grid item xs={12}>
            <Paper sx={{ p: 0.5, mb: 0.5 }}>
              <h5 style={{ margin: '0 0 10px 0', color: colors.bluePrimary }}>🔍 Pesquisar Clientes</h5>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    name="nome"
                    label="Nome"
                    size="small"
                    fullWidth
                    variant="outlined"
                    value={formPesquisar.nome}
                    onChange={(e) => handleInputPesquisar("nome", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="documento"
                    label="Documento"
                    size="small"
                    fullWidth
                    variant="outlined"
                    value={formPesquisar.documento}
                    onChange={(e) => handleInputPesquisar("documento", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    sx={{ height: '40px' }}
                    onClick={() => PesquisarPor(formPesquisar)}
                  >
                    Pesquisar
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={3}></Grid>
              </Grid>
            </Paper>
          </Grid>
  
          {/* Seção Tabela de Clientes */}
          <Grid item xs={12}>
            <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: 3 }}>
              <Box sx={{ p: 1, bgcolor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                <h5 style={{ margin: 0, color: colors.bluePrimary }}>📋 Lista de Clientes</h5>
              </Box>
              <TableContainer sx={{ maxHeight: 400 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          sx={{ 
                            fontWeight: 'bold',
                            bgcolor: '#f5f5f5',
                            color: colors.bluePrimary,
                            minWidth: column.minWidth
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                      <TableCell 
                        sx={{ 
                          fontWeight: 'bold',
                          bgcolor: '#f5f5f5',
                          color: colors.bluePrimary
                        }}
                      >
                        Ações
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.length > 0 &&
                      rows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                          <TableRow 
                            hover 
                            key={row.id}
                            sx={{ 
                              bgcolor: index % 2 === 0 ? '#ffffff' : '#fafafa',
                              '&:hover': { bgcolor: '#e3f2fd' }
                            }}
                          >
                            {columns.map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell 
                                  key={column.id} 
                                  align={column.align}
                                  sx={{ 
                                    borderBottom: '1px solid #e0e0e0',
                                    fontSize: '14px'
                                  }}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </TableCell>
                              );
                            })}
                            <TableCell sx={{ borderBottom: '1px solid #e0e0e0' }}>
                              <Grid container spacing={1}>
                                <Grid item>
                                  <Button
                                    size="small"
                                    color="primary"
                                    onClick={() => handleOpenModal(row)}
                                    sx={{ minWidth: 'auto', p: 1 }}
                                  >
                                    <EditIcon />
                                  </Button>
                                </Grid>
                                <Grid item>
                                  <Button
                                    size="small"
                                    color="error"
                                    onClick={() => handleDeleteItem(row)}
                                    sx={{ minWidth: 'auto', p: 1 }}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </Grid>
                              </Grid>
                            </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ 
                  bgcolor: '#f8f9fa',
                  borderTop: '1px solid #e0e0e0'
                }}
              />
            </Paper>
          </Grid>
  
            <ModalEditarCliente
              open={openModal}
              onClose={handleCloseModal}
              onConcluir={ConcluirEdicao}
              produto={clienteEdicao}
              loading={loading}
              canaisDeComunicacao={canaisDeComunicacao}
            />
          </Grid>
        </Paper>
      </Box>
    );  
}
